import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CmsService, GlobalMessageService, GlobalMessageType, ProductScope, ProductService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { NotifyMePayload, NotifyMeService } from 'src/app/service/notify-me/notify-me.service';

@Component({
  selector: 'app-notify-me',
  templateUrl: './notify-me.component.html',
  styleUrls: ['./notify-me.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NotifyMeComponent implements OnInit, OnDestroy, OnChanges {
  @Input() productCode: string;
  @Input() isModal: boolean = false;

  private payload = {
    active: false,
  };

  isNotifyMeShow: boolean;
  isNotifyMeChecked: boolean;

  productSubscription: Subscription;
  notifySubscription: Subscription;

  constructor(
    protected notifyService: NotifyMeService,
    protected currentProductService: CurrentProductService,
    protected productService: ProductService,
    protected cmsService: CmsService,
    private cdr: ChangeDetectorRef,
    private messageService: GlobalMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.productCode) {
        this.getProductByCode(this.productCode);
        this.cdr.markForCheck();
      }
    }
  }

  ngOnInit() {}

  getProductByCode(code: string) {
    this.productSubscription = this.productService
      .get(code, ProductScope.DETAILS)
      .pipe(
        filter(Boolean),
        map((data: any) => {
          if (data && data.notifyMe) {
            return data.notifyMe;
          } else {
            this.isNotifyMeShow = false;
          }
        })
      )
      .subscribe((product: any) => {
        this.isNotifyMeShow = product.show;

        if (this.isNotifyMeShow) {
          const isActive = product.active;
          this.isNotifyMeChecked = isActive ? isActive : false;
        }
        this.cdr.detectChanges();
      });
  }

  onChangeNotifyMeToggle(event: MatSlideToggleChange) {
    if (event) {
      const isChecked = event.checked;
      this.payload = { active: isChecked };
      this.updateNotifyMe(this.payload, this.productCode, isChecked);
      this.cdr.detectChanges();
    }
  }

  updateNotifyMe(payload: NotifyMePayload, productCode: string, isChecked: boolean) {
    this.notifySubscription = this.notifyService.updateNotifyMe(payload, productCode, isChecked).subscribe(() => {
      this.notifyService.loadProduct(productCode);
      this.getProductByCode(productCode);
      if (isChecked) {
        this.showGlobalMessage('stockNotification.getNotify', GlobalMessageType.MSG_TYPE_CONFIRMATION, productCode);
      }
    });
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType, param?: string) {
    this.messageService.add({ key: text, params: { skuNumber: param } }, messageType);
  }

  ngOnDestroy() {
    this.productSubscription?.unsubscribe();
    this.notifySubscription?.unsubscribe();
  }
}
